var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3463",
    "data-name": "Group 3463",
    transform: "translate(-571 -196)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3610",
    "data-name": "Rectangle 3610",
    width: 25,
    height: 25,
    rx: 2,
    transform: "translate(571 196)",
    fill: "#c2fae5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "noun-delet-4151532",
    d: "M141.951,68.055a2.6,2.6,0,0,0,2.6,2.6h6.5a2.6,2.6,0,0,0,2.6-2.6V57.649h1.3a.65.65,0,1,0,0-1.3h-3.31a3.9,3.9,0,0,0-7.688,0h-3.31a.65.65,0,1,0,0,1.3h1.3ZM147.8,54.4a2.6,2.6,0,0,1,2.517,1.951h-5.034A2.6,2.6,0,0,1,147.8,54.4Zm-3.252,3.252h7.8V68.055a1.3,1.3,0,0,1-1.3,1.3h-6.5a1.3,1.3,0,0,1-1.3-1.3V57.649Zm.65,9.105v-6.5a.65.65,0,1,1,1.3,0v6.5a.65.65,0,1,1-1.3,0Zm3.9,0v-6.5a.65.65,0,0,1,1.3,0v6.5a.65.65,0,1,1-1.3,0Z",
    transform: "translate(436 146.88)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBtn);
export default __webpack_public_path__ + "static/media/trash_btn.0aa75d0b13e7238e1b1d38606a1370cb.svg";
export { ForwardRef as ReactComponent };